require("@rails/ujs").start()

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo;

import '../stylesheets/widget';

import SlotPicker from '../components/SlotPicker';
import ManifestInput from '../components/ManifestInput';
import AddressInput from '../components/AddressInput';
import WidgetGiftaid from '../components/WidgetGiftaid';
import PhotoUploader from '../apps/PhotoUploader';

import mountComponents from '../utilities/mounter';

require("bootstrap")

window.API_BASE = '/api/v0/';

window.objectValues = function(obj) {
  var res = [];
  for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
          res.push(obj[i]);
      }
  }
  return res;
}

window.resizeIframe = function() {
  const height = Math.max(document.body.clientHeight,400);

  console.log("Setting iframe height to ", height);
  window.parent.postMessage(['setHeight', `${height}px`], '*');
}

document.addEventListener("turbo:load", function() {
  console.log("Mounting")
  mountComponents({
    SlotPicker,
    ManifestInput,
    AddressInput,
    WidgetGiftaid,
    PhotoUploader,
  });
  setInterval( () => {
    resizeIframe();
  }, 500);
});
